import React from 'react';

import mobileIcons from '@/assets/icons/minimized_button/mobile/index.json';
import BotIcon from '@/assets/icons/minimized_button/Bot.svg';
import BubbleIcon from '@/assets/icons/minimized_button/Bubble.svg';
import AiIcon from '@/assets/icons/minimized_button/Ai.svg';
import OneStarIcon from '@/assets/icons/minimized_button/OneStar.svg';
import TwoStarsIcon from '@/assets/icons/minimized_button/TwoStars.svg';

export type SettingsMinimizedButtonLayout = 'floating' | 'sticky' | 'icon';
export type SettingsMinimizedButtonDisplay = 'textIcon' | 'text' | 'icon';
export type SettingsMinimizedButtonPlayAnimation = 'loop' | 'hove' | 'load';

export const CUSTOM_MINIMIZED_BUTTON_ICON = 'custom';
export const NO_MINIMIZED_BUTTON_ICON = 'none';

export const icons = [
  {
    value: 'ai',
    illustration: React.createElement(AiIcon),
    mobile: mobileIcons.Frame420Icon,
  },
  {
    value: 'magic-1',
    illustration: React.createElement(TwoStarsIcon),
    mobile: mobileIcons.TwoStarsIcon,
  },
  {
    value: 'magic-2',
    illustration: React.createElement(OneStarIcon),
    mobile: mobileIcons.OneStarIcon,
  },
  {
    value: 'magic-3',
    illustration: React.createElement(BubbleIcon),
    mobile: mobileIcons.ChatStarIcon,
  },
  {
    value: 'robot',
    illustration: React.createElement(BotIcon),
    mobile: mobileIcons.ChatBotIcon,
  },
];

export const DEFAULT_MINIMIZED_BUTTON_ICON = icons[0].value;

const mapIconsByValue = <T,>(getValue: (icon: (typeof icons)[number]) => T) =>
  icons.reduce((acc, icon) => {
    acc[icon.value] = getValue(icon);
    return acc;
  }, {} as Record<string, T>);

export const iconsDict = mapIconsByValue((icon) => icon.illustration);

export const mobileIconsDict = mapIconsByValue((icon) => icon.mobile);

export const getFallbackMinimizedButtonIcon = () =>
  iconsDict[DEFAULT_MINIMIZED_BUTTON_ICON];

export const getMobileMinimizedButtonIcon = (icon?: string | null) =>
  mobileIconsDict[icon ?? ''] ?? mobileIconsDict[DEFAULT_MINIMIZED_BUTTON_ICON];

export const MinimizedButtonIcon = ({
  icon,
  customIconSrc,
  className,
}: {
  icon?: string | null;
  customIconSrc?: string | null;
  className?: string;
}) => {
  if (icon === NO_MINIMIZED_BUTTON_ICON) {
    return null;
  }

  if (icon === CUSTOM_MINIMIZED_BUTTON_ICON && customIconSrc) {
    return React.createElement('img', {
      className,
      src: customIconSrc,
      alt: '',
    });
  }

  return (icon && iconsDict[icon]) || getFallbackMinimizedButtonIcon();
};
